export default __webpack_public_path__ + "static/media/sounds/TRO_Red_Bike.mp3";